export default __webpack_public_path__ + "static/media/bconsole.feb5f3da.svg";